// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-component-library-Select-SearchableSelect-styles-___styles__rootClass___O2MNj {
  border: 1px solid #cbd5e0 !important;
  border-radius: 4px;
  padding: 0px 10px !important;
  width: 100%;
  margin: 0px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border: 1px solid var(--color-silver) !important;
}

.client-component-library-Select-SearchableSelect-styles-___styles__rootClass___O2MNj > div::before,
.client-component-library-Select-SearchableSelect-styles-___styles__rootClass___O2MNj > div::after {
  border: none !important;
}

.client-component-library-Select-SearchableSelect-styles-___styles__select-with-search__value-container___YzgT_ {
  height: 1px;
}

.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border-radius: 4px;
}

.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u,
.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u > div[class*='control'],
.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u > div[class*='control'] > div[class*='value-container'],
.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u > div[class*='control'] > div[class*='indicators'] {
  min-height: 28px !important;
  height: 28px !important;
  max-height: 28px !important;
  font-size: 0.75rem;
  font-weight: inherit;
}

.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u
  > div[class*='control']
  > div[class*='value-container']
  > div[class*='single-value'] {
  color: inherit !important;
  font-size: 0.85rem;
}

.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u
  > div[class*='control']
  > div[class*='indicators']
  > span[class*='indicator-separator'] {
  display: none;
}

.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u
  > div[class*='control']
  > div[class*='indicators']
  > div[class*='indicator'] {
  padding: 0px;
}

.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u
 input {
  margin-left: 5px !important;
}
.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u
[class*='input-container'] {
  grid-template-columns: inherit !important;
}
.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelectCopyable___GWSqB
[class*='value-container--has-value'] {
  grid-template-columns: auto 16px !important;
  padding-right: 0;
}
.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelectInherit___NR6Pj,
.client-component-library-Select-SearchableSelect-styles-___styles__simpleSelectInherit___NR6Pj > div[class*='control'] {
  box-shadow: inherit;
  border: inherit;
}

`, "",{"version":3,"sources":["webpack://./client/component-library/Select/SearchableSelect/styles/styles.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,2EAA2E;EAC3E,gDAAgD;AAClD;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2EAA2E;EAC3E,kBAAkB;AACpB;;AAEA;;;;EAIE,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;EAIE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,yCAAyC;AAC3C;AACA;;EAEE,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".rootClass {\n  border: 1px solid #cbd5e0 !important;\n  border-radius: 4px;\n  padding: 0px 10px !important;\n  width: 100%;\n  margin: 0px !important;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--color-silver) !important;\n}\n\n.rootClass > div::before,\n.rootClass > div::after {\n  border: none !important;\n}\n\n.select-with-search__value-container {\n  height: 1px;\n}\n\n.simpleSelect {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  border-radius: 4px;\n}\n\n.simpleSelect,\n.simpleSelect > div[class*='control'],\n.simpleSelect > div[class*='control'] > div[class*='value-container'],\n.simpleSelect > div[class*='control'] > div[class*='indicators'] {\n  min-height: 28px !important;\n  height: 28px !important;\n  max-height: 28px !important;\n  font-size: 0.75rem;\n  font-weight: inherit;\n}\n\n.simpleSelect\n  > div[class*='control']\n  > div[class*='value-container']\n  > div[class*='single-value'] {\n  color: inherit !important;\n  font-size: 0.85rem;\n}\n\n.simpleSelect\n  > div[class*='control']\n  > div[class*='indicators']\n  > span[class*='indicator-separator'] {\n  display: none;\n}\n\n.simpleSelect\n  > div[class*='control']\n  > div[class*='indicators']\n  > div[class*='indicator'] {\n  padding: 0px;\n}\n\n.simpleSelect\n input {\n  margin-left: 5px !important;\n}\n.simpleSelect\n[class*='input-container'] {\n  grid-template-columns: inherit !important;\n}\n.simpleSelectCopyable\n[class*='value-container--has-value'] {\n  grid-template-columns: auto 16px !important;\n  padding-right: 0;\n}\n.simpleSelectInherit,\n.simpleSelectInherit > div[class*='control'] {\n  box-shadow: inherit;\n  border: inherit;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootClass": `client-component-library-Select-SearchableSelect-styles-___styles__rootClass___O2MNj`,
	"select-with-search__value-container": `client-component-library-Select-SearchableSelect-styles-___styles__select-with-search__value-container___YzgT_`,
	"simpleSelect": `client-component-library-Select-SearchableSelect-styles-___styles__simpleSelect___Z7l8u`,
	"simpleSelectCopyable": `client-component-library-Select-SearchableSelect-styles-___styles__simpleSelectCopyable___GWSqB`,
	"simpleSelectInherit": `client-component-library-Select-SearchableSelect-styles-___styles__simpleSelectInherit___NR6Pj`
};
export default ___CSS_LOADER_EXPORT___;
